import { CategoryIcons } from '@/components/icons/CategoryIcons';
import { Picture } from '@/components/image/Image';
import { Card } from '@/components/sections/Card';
import { PurchaseOrderBundle } from '@/services/api/contracts/catalog/bundles';
import { Product } from '@/services/api/contracts/catalog/types';
import { usePrintCurrencyStringForCurrentCustomer } from '@/utils/price';
import { FC } from 'react';
import { PurchaseOrderActionsMenu } from './PurchaseOrderActionsMenu';
import { PurchaseOrderStatusChit } from './PurchaseOrderStatusChit';
import { usePurchaseOrderDetails } from './usePurchaseOrderDetails';

interface Props {
  order: PurchaseOrderBundle;
  submitted?: boolean;
}

interface ProductImageProps {
  product?: Product;
}

const ProductImage: FC<ProductImageProps> = ({ product }) => {
  return (
    <div className="h-[100px] w-[150px] flex items-center justify-center">
      {product?.imageUri?.id ? (
        <Picture image={product.imageUri} containerHeight={80} containerWidth={150}></Picture>
      ) : (
        <div className="w-full h-[100px] [&_svg]:w-[100%] [&_svg]:h-[100%]">
          {CategoryIcons[product?.category.description || '']}
        </div>
      )}
    </div>
  );
};

export const PurchaseOrderCard: FC<Props> = ({ order, submitted }) => {
  const { products, productNameString, totalCost, totalDeviceFee } = usePurchaseOrderDetails(order);
  const printCurrencyString = usePrintCurrencyStringForCurrentCustomer();

  return (
    <>
      <Card className="flex items-center">
        <ProductImage product={products[0]} />
        <div className="flex-1 px-5 py-2 border-l border-secondary-std flex flex-col relative">
          <p className="font-semibold text-xl">{order.name}</p>
          <p className="font-semibold text-primary-600 flex-1">{productNameString}</p>
          {submitted && <PurchaseOrderStatusChit status={order.state} className="mb-2" />}
          <p className="font-semibold text-primary-800 text-lg">
            {printCurrencyString(totalCost + (totalDeviceFee ?? 0))}
          </p>
        </div>
        <PurchaseOrderActionsMenu order={order} submitted={submitted} />
      </Card>
    </>
  );
};
